// import packages
import gql from "graphql-tag"

// export gqls
export const GET_MAINTAIN_HISTORIES = gql`
  query MaintainHistories {
    maintainHistories {
      total
      data {
        id
        content
        maintenanceTime
        type
        companyDevice {
          id
          number
          device {
            id
            name
          }
          company {
            id
            name
          }
        }
        product {
          id
          name
          category {
            id
            name
            isEnable
          }
          subcategory {
            id
            name
            isEnable
          }
        }
        user {
          id
          name
        }
      }
    }
  }
`

export const SUM_MAINTAIN_HISTORIES = gql`
  query MaintainHistories {
    maintainHistories(take: 0) {
      total
    }
  }
`

export const GET_TABLE_FIELDS = gql`
  query MaintainHistoryFields {
    maintainHistoryFields @client {
      name
      title
      order
      show
    }
  }
`

export const GET_MAINTAIN_HISTORY = gql`
  query MaintainHistory($id: ID!) {
    maintainHistory(id: $id) {
      id
      content
      maintenanceTime
      companyDevice {
        id
        number
        company {
          id
          name
        }
        device {
          id
          name
          number
        }
      }
      product {
        id
        name
        category {
          id
          name
          isEnable
        }
        subcategory {
          id
          name
          isEnable
        }
      }
    }
  }
`

export const UPDATE_MAINTAIN_HISTORY = gql`
  mutation UpdateMaintainHistory(
    $id: ID!
    $input: MaintainHistoryUpdateInput!
  ) {
    updateMaintainHistory(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_MAINTAIN_HISTORY = gql`
  mutation CreateMaintainHistory($input: MaintainHistoryCreateInput!) {
    createMaintainHistory(input: $input) {
      id
    }
  }
`

export const DELETE_MAINTAIN_HISTORY = gql`
  mutation DeleteMaintainHistory($id: ID!) {
    deleteMaintainHistory(id: $id)
  }
`

export const GET_CATEGORIES = gql`
  query categories {
    categories {
      data {
        id
        name
        isEnable
        subcategories {
          id
          name
          isEnable
        }
      }
    }
  }
`
export const GET_SUBCATEGORIES = gql`
  query subcategories {
    subcategories {
      data {
        id
        name
        isEnable
        products {
          id
          name
        }
      }
    }
  }
`

export const GET_COMPANIES = gql`
  query Companies {
    companies {
      data {
        id
        name
        area
        users {
          id
          name
        }
        companyDevices {
          id
          number
          device {
            id
            number
            name
          }
        }
      }
    }
  }
`
